import {
  useLayout,
  useResponsive,
  useSiteContext,
} from '@dustin-web/microsite-components/src/hooks'
import React from 'react'
import { CategoryPanels, CategorySEOContent } from '.'
import { CategoryLandingType } from '../filters'
import Categories from './categories'
import CategoriesThumbnail from './categories-thumbnail'
import ProductsiteBreadcrumbs from '../utils/productsite-breadcrumbs'
import classNames from 'classnames'
import { ZoneWithData } from '@dustin-web/product-components/src/panels'
import { DigitalData } from '@dustin-web/microsite-components/src/utils/digital-data'

type Props = {
  categoryId: string
  category: CategoryLandingType
  loading: boolean
}

const CategoryPage = ({ categoryId, category }: Props) => {
  const navigation = category.navigation
  if (!navigation || !navigation.path) {
    return null
  }

  const path = navigation.path
  const isTopCategory = path.length === 1
  const filteredNavigationChildren = navigation.children.filter(item => item.category !== null)
  const itemOnClick = (selection: string) => {
    DigitalData.pushCatMenuItemClick(selection)
  }

  return (
    <Container isTopCategory={isTopCategory}>
      <div className="container">
        <ProductsiteBreadcrumbs path={path} />
      </div>
      <div className="container">
        {!isTopCategory && (
          <div className="c-category-seo-content u-mb-16">
            <CategorySEOContent categoryId={categoryId} category={category} />
          </div>
        )}
      </div>
      {filteredNavigationChildren.length > 0 && (
        <div className="container u-pt-16 u-pb-16">
          <CategoriesThumbnail items={navigation.children} itemOnClick={itemOnClick} />
        </div>
      )}
      {categoryId === '2037751' && <ZoneContainer />}
      {!isTopCategory && (
        <div className="c-box c-box--section u-bg-gray-02 u-pt-0">
          <CategoryPanels categoryId={categoryId} category={category} />
        </div>
      )}

      <Section>
        <div className="container u-pb-32">
          <h1 className="h2 u-mb-24 u-pt-8">{category.seoLongTitleName ?? category.name}</h1>
          <Categories
            items={navigation.children}
            categoryId={categoryId}
            isTopCategory={isTopCategory}
            itemOnClick={itemOnClick}
          />
        </div>
      </Section>

    </Container>
  )
}

const Section = ({ children }: { children: React.ReactNode }) => {
  const { responsive } = useLayout()
  return (
    <div
      className={classNames({
        'c-box c-box--section': responsive.breakpoints.min.SM,
      })}>
      {children}
    </div>
  )
}

const ZoneContainer = () => {
  const { isBusiness } = useSiteContext()
  const panelPath = isBusiness ? '/category-page' : '/category-page-consumer'
  return (
    <ZoneWithData
      isNotAvailable={false}
      zoneAlias={'voxiconLabelCategory'}
      panelPath={panelPath}
      usePanelClasses
    />
  )
}

const Container = ({
  children,
  isTopCategory,
  bottomPadding = true,
}: {
  children: React.ReactNode
  isTopCategory: boolean
  bottomPadding?: boolean
}) => {
  const { isSmallScreen } = useResponsive()
  return (
    <div
      id="page-container"
      className={classNames('u-attach-section u-px-0', {
        'u-bg-white': isTopCategory && !isSmallScreen,
        'u-pb-48': bottomPadding,
      })}
      data-gasource="CategoryLandingPage">
      {children}
    </div>
  )
}
export default CategoryPage
